import type { CSSProperties } from "react";
import clsx from "clsx";

export function BgOverlay(props: {
  startTime: Date;
  duration?: number;
  className?: string;
  delay?: number;
  color?: string;
}) {
  const now = Date.now();
  const startedAt = props.startTime.getTime();
  const elapsed = now - startedAt;
  const extraDelay = props.delay ?? 0;
  const totalDuration = props.duration ?? 35000;

  // Already past the animation window
  if (elapsed > totalDuration + extraDelay) return null;

  const animationDelay = -(elapsed - extraDelay) / 1000;
  const animationDuration = totalDuration / 1000;

  return (
    <div
      className={clsx(
        "absolute inset-y-0 left-0 w-[3px] z-10 rounded-r animate-hold-then-fade",
        props.className
      )}
      style={{
        animationDelay: `${animationDelay}s`,
        animationDuration: `${animationDuration}s`,
        ...(props.color ? { "--accent": props.color } : {}),
      } as CSSProperties}
    />
  );
}
